<template>
  <v-layout wrap align-center justify-center class="pa-2">
    <v-flex xs12>
      <lister
        searchText
        hideSearchbar
        emptyListIcon
        :autosort="false"
        :ref="'sortableLister'"
        :cardBreakpoints="'xs12'"
        :emptyListMessage="'Nenhum item carregado...'"
        :items="editingArray"
        :customSearchFunction="customSearch"
      >
        <template v-slot:default="slotProps">
          <v-card class="my-2">
            <v-card-text>
              <v-layout align-center>
                <v-icon style="cursor: move" class="handle">drag_indicator</v-icon>
                <v-flex xs12 style="pointer-events: none;">
                  <slot v-bind:item="slotProps.item" v-bind:index="slotProps.index"></slot>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </template>
      </lister>
    </v-flex>
  </v-layout>
</template>

<script>
import Lister from "@/components/Lister";
import Sortable from "sortablejs";

export default {
  components: { Lister },
  data: () => ({
    editingArray: []
  }),
  watch: {
    originalArray: {
      immediate: true,
      handler(v) {
        this.editingArray = v.slice();
        this.updateValue(this.editingArray);
      }
    }
  },
  mounted() {
    let lister = this.$refs.sortableLister.$el.getElementsByClassName(
      "sortableContainer"
    )[0];
    Sortable.create(lister, {
      draggable: ".sortable",
      handle: ".handle",
      onEnd: this.dragReorder
    });
  },
  props: {
    originalArray: {
      type: Array
    }
  },
  methods: {
    dragReorder({ oldIndex, newIndex }) {
      const movedItem = this.editingArray.splice(oldIndex, 1)[0]; // tira elemento do index antigo
      this.editingArray.splice(newIndex, 0, movedItem); // acrescenta elemento no index novo
      this.updateValue(this.editingArray);
      return true;
    },
    itemKey(item) {
      if (!this.itemKeys.has(item))
        this.itemKeys.set(item, ++this.currentItemKey);
      return this.itemKeys.get(item);
    },
    customSearch() {
      return () => {
        return true;
      };
    },
    updateValue: function(value) {
      this.$emit("arrayReordered", value);
    }
  }
};
</script>
